"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpDotsHorizontalScroll = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_bootstrap_1 = require("react-bootstrap");
var DpDotsHorizontalScroll_styled_1 = require("./DpDotsHorizontalScroll.styled");
var elementsToShow = 6;
var createListItems = function (elements, navigateItem) {
    return elements.slice(0, elementsToShow).map(function (element, index) {
        var itemPositionIndex = "#".concat(index);
        return ((0, jsx_runtime_1.jsx)(react_bootstrap_1.ListGroup.Item, { as: "li", action: true, href: itemPositionIndex, onClick: navigateItem(element), children: (0, jsx_runtime_1.jsx)("span", { children: element.label }) }, itemPositionIndex));
    });
};
/**
 * DpDotsHorizontalScroll
 * @property {Array}       elements        - List of elements(dots) to show
 * @property {string}      position        - Default value for the initial position
 * @property {Function}    navigationHandler  - Callback fired when the element item is clicked
 *
 */
var DpDotsHorizontalScroll = function (_a) {
    var elements = _a.elements, position = _a.position, navigationHandler = _a.navigationHandler;
    var navigateItem = function (element) { return function (e) {
        navigationHandler(element);
    }; };
    var items = createListItems(elements, navigateItem);
    var positionIndex = "#".concat(position);
    return ((0, jsx_runtime_1.jsx)(DpDotsHorizontalScroll_styled_1.StyledListGroup, { children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.ListGroup, { as: "ul", defaultActiveKey: positionIndex, children: items }) }));
};
exports.DpDotsHorizontalScroll = DpDotsHorizontalScroll;
exports.default = exports.DpDotsHorizontalScroll;
